import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'

// ANGULAR MODULES //
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

// MAT MODULES //
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatDialogModule } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'

// LIBS MODULES
import { ZXingScannerModule } from '@zxing/ngx-scanner'
import { TranslateModule } from '@ngx-translate/core'

// import { QRCodeModule } from 'angularx-qrcode'

// LOCAL MODULES

// LOCAL COMPONENTS
import { MapBaseComponent } from './components/map-base/map-base.component'
import { OverlayComponent } from './components/overlay/overlay.component'
import { InfoBarComponent } from './components/info-bar/info-bar.component'
import { ItemGroupNotFoundComponent } from './components/item-group-not-found/item-group-not-found.component'
import { ItemGroupComponent } from './components/item-group/item-group.component'
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component'
import { ScanTagInputComponent } from './components/scan-tag-input/scan-tag-input.component'
import { ScanTagDialogComponent } from './components/scan-tag-input/scan-tag-dialog/scan-tag-dialog.component'
import { PingComponent } from './components/ping/ping.component'
import { GenericScoreStrengthComponent } from './components/generic-score-strength/generic-score-strength.component'

// LOCAL DIRECTIVES

// LOCAL PIPES
import { CustomDatePipe } from './pipes/dates/custom-date.pipe'

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    ZXingScannerModule,
    TranslateModule,
    MapBaseComponent,
    OverlayComponent,
    CustomDatePipe,
    InfoBarComponent,
    ItemGroupNotFoundComponent,
    ItemGroupComponent,
    ConfirmationDialogComponent,
    ScanTagInputComponent,
    ScanTagDialogComponent,
    PingComponent,
    GenericScoreStrengthComponent,
  ],
  exports: [
    MapBaseComponent,
    OverlayComponent,
    CustomDatePipe,
    InfoBarComponent,
    ItemGroupNotFoundComponent,
    ItemGroupComponent,
    ScanTagInputComponent,
    ScanTagDialogComponent,
    PingComponent,
    GenericScoreStrengthComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonsModule { }
